/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

const ComparisonDocList = ({
  documents,
  current,
  handleSelectedDocument,
}) => {
  const [docList, setDocList] = useState(null);

  useEffect(() => {
    const newList = [];
    newList.push({ title: '-Select document to compare-', id: '-' });
    documents &&
      documents
        .filter((doc) => doc.id !== current.id)
        .forEach((doc) => {
          newList.push({ title: doc.title, id: doc.id });
        });
    setDocList(newList);
  }, [current]);

  const handleDocSelected = (id) => {
    id !== '-' && handleSelectedDocument(id);
  };

  return (
    <div className="w-100">
      <select
        className="form-control"
        onChange={(option) => handleDocSelected(option.target.value)}
        title="Select document to compare"
      >
        {docList &&
          docList.length > 0 &&
          docList
            .sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }))
            .map((doc, index) => (
              <option value={doc.id} key={index}>
                {doc.title}
              </option>
            ))}
      </select>
    </div>
  );
};

const mapStateToProps = (state) => ({
  documents: state.client.documents,
  current: state.document.currentDocument,
});

const connector = connect(mapStateToProps, null);

export default connector(ComparisonDocList);
